export {default as fuseDark} from './fuseDark';


// WEBPACK FOOTER //
// src/@fuse/fuse-colors/index.js